import "./ServiceNameInLimassolNicosiaCyprus.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TreatmentAreasWhatToExpect from "./sections/TreatmentAreasWhatToExpect";
import OurValues from "./sections/OurValues";
import TheRainfallPatientJourney from "./sections/TheRainfallPatientJourney";
import WhoWeHelp from "./sections/WhoWeHelp";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ServiceNameInLimassolNicosiaCyprusPage() {
  return <div>
      <Header />
      <Hero />
      <TreatmentAreasWhatToExpect />
      <OurValues />
      <TheRainfallPatientJourney />
      <WhoWeHelp />
      <FrequentlyAskedQuestions />
      <CallToAction />
      <Footer />
    </div>;
}